export default __webpack_public_path__ + "mockup_manager_app.cc11493.svg";